
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

@Component
export default class ConfirmModal<T> extends Vue {
  @Prop({ type: String, default: 'Confirmation' })
  private readonly title!: string

  @Prop({ type: String, default: '' })
  private readonly subtitle!: string

  @Prop({ type: String, default: 'Cancel' })
  private readonly cancelText!: string

  @Prop({ type: String, default: 'Confirm' })
  private readonly confirmText!: string

  show = false

  data: T | null = null

  open(data: T) {
    this.show = true
    this.data = data
  }

  close() {
    this.show = false
    this.data = null
  }

  confirm() {
    this.$emit('confirm', this.data)
    this.close()
  }
}
